import { useLocation, useNavigate } from 'react-router-dom'
import React, { createContext, useEffect, useLayoutEffect, useState } from 'react'
import i18n from 'i18next'
import { initGA, removeGA } from './utils/tracking'

export type AppConsentContextType = {
  acceptedTerms: boolean;
  acceptTerms: () => void;
  isUserExperienceCookiesAllowed: boolean;
  setIsUserExperienceCookiesAllowed: (value: boolean) => void;
}

const fakeAppConsentCheck = () =>
  new Promise((resolve) => {
    setTimeout(() => resolve('2342f2f1d131rf12'), 250)
  })

export const AppConsentContext = createContext<AppConsentContextType | null>(null)


const AppConsentProvider = ({ children }) => {
  const navigate = useNavigate()
  const location = useLocation()
  let localStorageSupported = false
  try {
    localStorageSupported = (window.localStorage && true)
  } catch (e) {}

  // maybe use https://github.com/asaritech/react-device-storage#readme to also have session storage or cookies als fallback
  const [acceptedTerms, _setAcceptedTerms] = useState(localStorageSupported ? JSON.parse(localStorage.getItem('accepted-terms')) : false)
  const [isUserExperienceCookiesAllowed, _setIsUserExperienceCookiesAllowed] = useState((localStorageSupported && ('allow-ux-cookies' in localStorage)) ? JSON.parse(localStorage.getItem('allow-ux-cookies')) : true) // default is true

  useLayoutEffect(()=> { // we use useLayoutEffect to ensure we do it before other calls
    if (acceptedTerms && isUserExperienceCookiesAllowed)
      initGA()
  }, [])

  const setIsUserExperienceCookiesAllowed = (value) => {
    if (localStorageSupported)
      localStorage.setItem('allow-ux-cookies', JSON.stringify(value))
    _setIsUserExperienceCookiesAllowed(value)
  }

  const acceptTerms = async () => {
    // const acceptedCookie = await fakeCookieConsentCheck()
    if (acceptedTerms && !isUserExperienceCookiesAllowed) {
      removeGA()
    }
    if (localStorageSupported)
      localStorage.setItem('accepted-terms', 'true')
    _setAcceptedTerms(true)
    if (isUserExperienceCookiesAllowed)
      initGA()

    const origin = location.state?.from?.pathname || `/${i18n.resolvedLanguage}/station/1`
    navigate(origin)
  }

  return (
    <AppConsentContext.Provider value={{ acceptedTerms, acceptTerms, isUserExperienceCookiesAllowed, setIsUserExperienceCookiesAllowed }}>
      {children}
    </AppConsentContext.Provider>
  )
}

export default AppConsentProvider
